module.exports = __webpack_public_path__ + "static/img/b4.157a351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b4.jpg
// module id = JpkG
// module chunks = 1